import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const CompanyGlobalFinancialMonitoringSection = ({
  ...formProps
}: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="companyFinancialMonitoringSection"
      title={t('client.legal.companyGlobalFinancialMonitoring.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
